<template>
  <div class="heartbeat-loader-container" :class="containerClass">
    <div class="heartbeat-loader">
      <svg :width="size" :height="size" viewBox="0 0 40 40" class="heartbeat-svg">
        <path d="M5,20 Q10,10 15,20 T25,20 Q30,10 35,20" stroke="#10b981" stroke-width="2" fill="none" class="heartbeat-line"/>
      </svg>
    </div>
    <span v-if="text" class="heartbeat-text" :class="textClass">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'HeartbeatLoader',
  props: {
    size: {
      type: [String, Number],
      default: 40
    },
    text: {
      type: String,
      default: ''
    },
    containerClass: {
      type: String,
      default: 'flex items-center justify-center'
    },
    textClass: {
      type: String,
      default: 'ml-2 text-sm text-gray-600'
    }
  }
}
</script>

<style scoped>
.heartbeat-loader {
  display: flex;
  align-items: center;
  justify-content: center;
}

.heartbeat-svg {
  animation: heartbeat-pulse 1.5s ease-in-out infinite;
}

.heartbeat-line {
  stroke-dasharray: 50;
  stroke-dashoffset: 50;
  animation: heartbeat-draw 2s ease-in-out infinite;
}

@keyframes heartbeat-pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
}

@keyframes heartbeat-draw {
  0% {
    stroke-dashoffset: 50;
    opacity: 0.5;
  }
  50% {
    stroke-dashoffset: 0;
    opacity: 1;
  }
  100% {
    stroke-dashoffset: -50;
    opacity: 0.5;
  }
}

.heartbeat-loader-container {
  padding: 0.5rem;
}
</style> 